'use client'
import { useTranslations } from 'next-intl'
import { Controller, useForm } from 'react-hook-form'
import CompanySizeField from './CustomSelectField'
import GoldLinkButton from '@/components/GoldLinkButton'
import { useSearchParams } from 'next/navigation'
import { useAddBusinessAccount, useAddEventsAccount, useAddRolzoApiAccount } from 'src/lib/api/mailingService'
import { useRouter } from 'navigation'
const sizeOptions = [
  { title: '1-10', value: '1-10' },
  { title: '10-100', value: '10-100' },
  { title: '100-1,000', value: '100-1,000' },
  { title: '1,000+', value: '1,000+' },
]
const ContactForm = ({ eventsPage = false, contactApi = false }) => {
  const t = useTranslations('contactPage')
  const router = useRouter()
  const searchParams = useSearchParams()
  const { addBusinessAccount } = useAddBusinessAccount()
  const { addEventsAccount } = useAddEventsAccount()
  const { addRolzoApiAccount } = useAddRolzoApiAccount()

  const getUtmParameters = (searchParams) => {
    return {
      utmSource: searchParams.get('utm_source') || 'None',
      utmMedium: searchParams.get('utm_medium') || 'None',
      utmCampaign: searchParams.get('utm_campaign') || 'None',
      utmTerm: searchParams.get('utm_term') || 'None',
      utmContent: searchParams.get('utm_content') || 'None',
    }
  }
  const {
    control,
    handleSubmit,
    formState: { errors, isSubmitted },
  } = useForm({
    defaultValues: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      workEmail: '',
      companyWebsite: '',
      companySize: '1-10',
      anythingElse: '',
      eventreq: '',
      anythingElseAPI: '',
    },
    mode: 'onChange',
  })
  const onSubmit = async (formData) => {
    try {
      let data = {}
      let utmValues = getUtmParameters(searchParams)
      if (eventsPage) {
        data = {
          first_name: formData.firstName,
          last_name: formData.lastName,
          work_email: formData.workEmail,
          phone_number: formData.phoneNumber,
          company_website: formData.companyWebsite,
          additional_notes: formData.eventreq,
        }
      } else if (contactApi) {
        data = {
          first_name: formData.firstName,
          last_name: formData.lastName,
          work_email: formData.workEmail,
          company_website: formData.companyWebsite,
          additional_notes: formData.anythingElseAPI,
          company_size: formData.companySize
        }
      } else {
        data = {
          first_name: formData.firstName,
          last_name: formData.lastName,
          work_email: formData.workEmail,
          phone_number: formData.phoneNumber,
          company_website: formData.companyWebsite,
          company_size: formData.companySize,
          additional_notes: formData.anythingElse,
          utm_source: utmValues.utmSource,
          utm_medium: utmValues.utmMedium,
          utm_campaign: utmValues.utmCampaign,
          utm_term: utmValues.utmTerm,
          utm_content: utmValues.utmContent,
          url: window.location.href,
          referrer: document.referrer || 'None',
        }
      }
let response = null
      if (contactApi)  response = await addRolzoApiAccount(data)
     else if (eventsPage)  response = await addEventsAccount(data)
    else response = await addBusinessAccount(data)
      if (response.meta.success) {
        router.push({
          pathname: '/success',
          query: { email: formData.workEmail },
        })
      }
    } catch (error) {
      console.error('Error adding business account:', error)
    }
  }

  return (
    <div
      className={`col-span-7 shadow-contact-form bg-white py-[50px] px-[30px] rounded-[10px]`}
    >
      <form className='flex flex-col gap-7 ' onSubmit={handleSubmit(onSubmit)}>
        <div className='grid grid-cols-12 items-center gap-5'>
          <label className='col-span-full md:col-span-4 mb-[3.5px] md:mb-0 text-[14px] font-normal'>
            {t('form.labels.firstName')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='firstName'
              rules={{ required: 'This field is required' }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                    placeholder='Anna'
                    autoComplete='off'
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors.firstName
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors.firstName?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>

        <div className='grid grid-cols-12 items-center gap-5'>
          <label className='col-span-full md:col-span-4 mb-[3.5px] md:mb-0 text-[14px] font-normal'>
            {t('form.labels.lastName')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='lastName'
              rules={{ required: 'This field is required' }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                    autoComplete='off'
                    placeholder='Smith'
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors.lastName
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors.lastName?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>
        {!contactApi && (
          <div className='grid grid-cols-12 items-center gap-5'>
            <label className='col-span-full md:col-span-4 mb-[3.5px] md:mb-0 text-[14px] font-normal'>
              {t('form.labels.phoneNumber')}
            </label>
            <div className='col-span-full md:col-span-8 relative'>
              <Controller
                name='phoneNumber'
                rules={{ required: 'This field is required' }}
                control={control}
                render={({ field }) => (
                  <>
                    <input
                      autoComplete='off'
                      type='tel'
                      placeholder='+1 (XXX) XXX-XXX'
                      className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] border-[#0000001f]'
                      {...field}
                      ref={null}
                    />
                    <p
                      className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                        errors.phoneNumber
                          ? 'translate-y-[7px] opacity-100'
                          : 'translate-y-0 opacity-0'
                      }  left-[10px] font-light absolute text-[10.5px]`}
                    >
                      {errors.phoneNumber?.message}
                    </p>
                  </>
                )}
              />
            </div>
          </div>
        )}
        <div className='grid grid-cols-12 items-center gap-5'>
          <label className='col-span-full md:col-span-4 mb-[3.5px] md:mb-0 text-[14px] font-normal'>
            {t('form.labels.workEmail')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='workEmail'
              rules={{
                required: 'This field is required',
                pattern: {
                  value: /^[^@]+@[^@]+\.[^@]+$/,
                  message: 'Invalid email address',
                },
              }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                    type='email'
                    autoComplete='off'
                    placeholder='anna.smith@example.com'
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors.workEmail
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors.workEmail?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>

        <div className='grid grid-cols-12 items-center gap-5'>
          <label className='col-span-full md:col-span-4 mb-[3.5px] md:mb-0 text-[14px] font-normal'>
            {t('form.labels.companyWebsite')}
          </label>
          <div className='col-span-full md:col-span-8 relative'>
            <Controller
              name='companyWebsite'
              rules={{ required: 'This field is required' }}
              control={control}
              render={({ field }) => (
                <>
                  <input
                    autoComplete='off'
                    placeholder='example.com'
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                  <p
                    className={`text-[#d32f2f] transition-all duration-500 ease-in-out ${
                      errors.companyWebsite
                        ? 'translate-y-[7px] opacity-100'
                        : 'translate-y-0 opacity-0'
                    }  left-[10px] font-light absolute text-[10.5px]`}
                  >
                    {errors.companyWebsite?.message}
                  </p>
                </>
              )}
            />
          </div>
        </div>
        {!eventsPage && (
          <div className='grid grid-cols-12 items-center gap-5'>
            <label className='col-span-full md:col-span-4 mb-[3.5px] md:mb-0 text-[14px] font-normal'>
              {t('form.labels.companySize')}
            </label>
            <div className='col-span-full md:col-span-8 relative'>
              <Controller
                name='companySize'
                control={control}
                render={({ field }) => (
                  <CompanySizeField
                    options={sizeOptions}
                    selectedItemClassName='text-[14px]'
                    {...field}
                    ref={null}
                  />
                )}
              />
            </div>
          </div>
        )}
        {!eventsPage ? (
          <div className='grid grid-cols-12 items-start gap-5'>
            <label className='col-span-full md:col-span-4 mb-[3.5px] md:mb-0 text-[14px] font-normal'>
              {t('form.labels.anythingElse')}
            </label>
            <div className='col-span-full md:col-span-8 relative'>
              <Controller
                name={contactApi ? 'anythingElseAPI' : 'anythingElse'}
                control={control}
                render={({ field }) => (
                  <textarea
                    rows={6}
                    placeholder={t('form.placeholders.anythingElse')}
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                )}
              />
            </div>
          </div>
        ) : (
          <div className='grid grid-cols-12 items-start gap-5'>
            <label className='col-span-full md:col-span-4 mb-[3.5px] md:mb-0 text-[14px] font-normal'>
              {t('form.labels.eventRequirements')}
            </label>
            <div className='col-span-full md:col-span-8 relative'>
              <Controller
                name='eventreq'
                control={control}
                render={({ field }) => (
                  <textarea
                    rows={6}
                    placeholder={t('form.placeholders.eventRequirements')}
                    className='px-[0.75em] border placeholder:font-light py-[9.5px] focus:outline-none rounded-[5px] w-full text-[14px] border-[#0000001f]'
                    {...field}
                    ref={null}
                  />
                )}
              />
            </div>
          </div>
        )}
        <div className='flex items-center justify-end'>
          <GoldLinkButton
            text='Contact us'
            hasGoldBackground
            className='!text-[14px] !px-6 !py-[4px] leading-[36px]'
            type='submitBtn'
            isShowRightArrow={false}
          />
        </div>
      </form>
    </div>
  )
}

export default ContactForm
